import { render, staticRenderFns } from "./UserPublications.vue?vue&type=template&id=449a35d5"
import script from "./UserPublications.vue?vue&type=script&lang=js"
export * from "./UserPublications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports